import {
  FIND_ADDRESS_SUGGESTIONS,
  RETRIEVE_FULL_ADDRESS,
  VERIFY_USER_INPUTTED_ADDRESS
} from '@/utils/store/actionTypes'
import { serializeParameters } from '@/utils/general'
import { CountryCodes } from '@/enums/general'

const BASE_URL = 'https://api.addressy.com'

export default {
  /**
   * User starts typing an address and this endpoint returns the found suggestions
   * https://www.loqate.com/resources/support/apis/Capture/Interactive/Find/1.1/
   */
  async [FIND_ADDRESS_SUGGESTIONS] ({ rootState }, { Text = '', Limit = 10, Container = '', Countries = CountryCodes.france }) {
    const { locale: Language } = rootState.app

    const params = {
      Key: process.env.LOQATE_API_KEY,
      Language,
      Countries, // ISO 2 countrycodes https://www.iban.com/country-codes
      Text,
      Limit,
      Container
    }

    const response = await fetch(`${BASE_URL}/Capture/Interactive/Find/v1.1/json3.ws?${serializeParameters(params)}`)

    return await response.json()
  },

  /**
   * When user picks a suggestion, use this endpoint to retrieve the full address
   * https://www.loqate.com/resources/support/apis/Capture/Interactive/Retrieve/1.2/
   */
  async [RETRIEVE_FULL_ADDRESS] (_, { Id }) {
    const params = {
      Key: process.env.LOQATE_API_KEY,
      Id
    }

    const response = await fetch(`${BASE_URL}/Capture/Interactive/Retrieve/v1/json3.ws?${serializeParameters(params)}`)

    const data = await response.json()

    return data.Items[0]
  },

  /**
   * When the user adjusts the address manually, use this endpoint to check wether their
   * manually inputted address is valid or not
   * https://www.loqate.com/resources/support/cleanse-api/international-batch-cleanse/
   */
  async [VERIFY_USER_INPUTTED_ADDRESS] (_, { address, country = CountryCodes.france }) {
    const { building, floor, streetType, street, houseNumber, annex, postalCode, city, region } = address

    const body = {
      Key: process.env.LOQATE_API_KEY,
      Options: {
        Process: 'Verify',
        ServerOptions: {
          MaxResults: 200,
          OutputScript: 'Native',
          OutputAddressFormat: 'true',
          MinimumGeoAccuracyLevel: '5',
          FieldStatus: 'True'
        }
      },
      Addresses: [
        {
          Address: '',
          Address1: `${streetType ? `${streetType} ` : ''}${street} ${houseNumber} ${annex}${building}${floor}`,
          Address2: `${city ? `${city} ` : ''}${region}`,
          Address3: postalCode,
          Address4: '',
          Address5: '',
          Address6: '',
          Address7: '',
          Address8: '',
          Country: country.toUpperCase(),
          SuperAdministrativeArea: '',
          AdministrativeArea: '',
          SubAdministrativeArea: '',
          Locality: '',
          DependentLocality: '',
          DoubleDependentLocality: '',
          Thoroughfare: '',
          DependentThoroughfare: '',
          Building: '',
          Premise: '',
          SubBuilding: '',
          PostalCode: postalCode,
          Organization: '',
          PostBox: ''
        }
      ]
    }

    const headers = new Headers()
    headers.append('Content-Type', 'application/json')

    const options = {
      method: 'POST',
      body: JSON.stringify(body),
      headers
    }

    const response = await fetch(`${BASE_URL}/Cleansing/International/Batch/v1.00/json4.ws`, options)

    return await response.json()
  }
}
